export { default as Statistics } from './Statistics/Statistics'
export { default as ScoreBoard } from './ScoreBoard/ScoreBoard'
export { default as TotalScore } from './TotalScore/TotalScore'
